import {
  Navigate,
  type RouteObject,
} from "react-router-dom";

import { PlatformLayout } from "@/components/platform/layout/PlatformLayout";

import { PlatformProtectedRoute } from "@/features/platform-auth/components/PlatformProtectedRoute";
import { PlatformAuthRoot } from "@/features/platform-auth/components/PlatformAuthRoot";
import { PlatformIntelligencePage } from "@/pages/platform/PlatformIntelligencePage";
import { PlatformLoginPage } from "@/features/platform-auth/pages/PlatformLoginPage";

import { PilotRequestsPage } from "@/pages/platform/PilotRequestsPage";
import { PlatformChurchesPage } from "@/pages/platform/PlatformChurchesPage";
import { PlatformDashboardPage } from "@/pages/platform/PlatformDashboardPage";
import { PlatformInvitationsPage } from "@/pages/platform/PlatformInvitationsPage";

export const platformRoutes: RouteObject[] = [
  {
    element: <PlatformAuthRoot />,
    children: [
      {
        path: "/login",
        element: <PlatformLoginPage />,
      },

      // Temporary compatibility redirects.
      {
        path: "/platform/login",
        element: <Navigate to="/login" replace />,
      },
      {
        path: "/platform",
        element: <Navigate to="/" replace />,
      },
      {
        path: "/platform/pilot-requests",
        element: (
          <Navigate
            to="/pilot-requests"
            replace
          />
        ),
      },
      {
        path: "/platform/churches",
        element: (
          <Navigate
            to="/churches"
            replace
          />
        ),
      },
      {
        path: "/platform/invitations",
        element: (
          <Navigate
            to="/invitations"
            replace
          />
        ),
      },

      {
        element: <PlatformProtectedRoute />,
        children: [
          {
            path: "/",
            element: <PlatformLayout />,
            children: [
              { path: "operations/intelligence", element: <PlatformIntelligencePage /> },
              {
                index: true,
                element: <PlatformDashboardPage />,
              },
              {
                path: "pilot-requests",
                element: <PilotRequestsPage />,
              },
              {
                path: "churches",
                element: <PlatformChurchesPage />,
              },
              {
                path: "invitations",
                element: <PlatformInvitationsPage />,
              },
            ],
          },
        ],
      },
    ],
  },
];
